import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cdgl",
  "use": "icon-cdgl-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-cdgl\"><defs><style type=\"text/css\"></style></defs><path d=\"M594.4 895.26H213.09a65 65 0 0 1-64.89-64.89V419a65 65 0 0 1 64.89-64.89H594.4A65 65 0 0 1 659.29 419v115.61a34.73 34.73 0 1 1-69.45 0V423.55H217.65v402.26h372.19v-87.22a34.73 34.73 0 1 1 69.45 0v91.78a65 65 0 0 1-64.89 64.89z\" p-id=\"5711\" /><path d=\"M816.91 672.75H435.6a65 65 0 0 1-64.89-64.89V497.37a34.73 34.73 0 1 1 69.45 0V603.3h372.19V201H440.16v77.42a34.73 34.73 0 1 1-69.45 0v-82a65 65 0 0 1 64.89-64.89h381.31a65 65 0 0 1 64.89 64.89v411.44a65 65 0 0 1-64.89 64.89z\" p-id=\"5712\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/cdgl.svg
// module id = dmtc
// module chunks = 5